import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './styles.css';
import { registerServiceWorker } from './lib/sw';

registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary area="micPlot">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
